<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Benefit Claim Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append v-if="(this.benefitclaimMenu!='hrm.benefitclaimself')">
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>

                    <b-input-group >
                      <b-input-group-prepend><label>Claim Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.TakenDate" type='date' :state="!$v.model.TakenDate.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Claim No.</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.nomor"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-textarea v-model="model.TakenReason" :state="!$v.model.TakenReason.$error" rows="2" max-rows="4"></b-form-textarea>
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Benefit Name</label></b-input-group-prepend>
                            <b-form-input v-model="model.NmClaim" readonly></b-form-input>
                              <b-input-group-append>
                              <b-btn text="Button" @click="lkuBenefitShow=true" >
                                  <i class="fa fa-search"></i>
                              </b-btn>
                              </b-input-group-append>
                        </b-input-group>                  
                      </b-col>
                      <b-col cols="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Entitlement</label></b-input-group-prepend>
                            <b-form-input v-model="model.Periode" readonly></b-form-input>
                              <b-input-group-append>
                              <b-btn text="Button" @click="lkuBenefitenttlShow=true" >
                                  <i class="fa fa-search"></i>
                              </b-btn>
                              </b-input-group-append>
                        </b-input-group>                  
                      </b-col>
                  </b-row>   
                    <b-row>
                      <b-col cols="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Plafon Entitlement</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                            <my-number v-model="model.TotPlatform" :precision="2"  readonly class="form-control text-right"></my-number>
                        </b-input-group>                  
                      </b-col>
                      <b-col cols="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Balance Entitlement</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                            <my-number v-model="model.PlatfrmBlc" :precision="2"  readonly class="form-control text-right"></my-number>
                        </b-input-group>                  
                      </b-col>
                  </b-row>   

                </b-col>
                <b-col lg="6">
                  <b-table
                      class="mb-0"
                      ref="tblDealLines"
                      outlined striped hover small
                      style="font-size:smaller;" 
                      :items="dealLines.items"
                      :fields="dealLines.fields"
                      :current-page="dealLines.page"
                      :per-page="dealLines.limit"
                        show-empty
                      >
                          <template v-slot:cell(tanggal)="data">
                            {{data.item.tanggal | moment('MMM-YYYY')}}
                          </template>
                          <template v-slot:cell(nilai)="data">
                          {{data.item.nilai|numFormat}}
                          </template>

                          <template v-slot:cell(action)="data">
                              <div class="text-center">
                              <a href="javascript:void(0)" @click="editDealLines(data.item,data.toggleDetails)">
                                  <i class="fa fa-pencil"></i>
                              </a>
                              |
                              <a href="javascript:void(0)" class="text-danger" @click="delDealLines(data.index)">
                                  <i class="fa fa-trash"></i>
                              </a>
                              </div>
                          </template>
                      <template v-slot:row-details="row">
                      <b-card class="row-details-form">
                          <b-row>
                            <b-col lg="7">
                              <b-input-group >
                                <b-input-group-prepend><label>Beneficiary</label></b-input-group-prepend>
                                <!-- <b-form-input v-model="dealLinesObj.penerima" placeholder="Penerima Manfaat"  :state="!$v.dealLinesObj.penerima.$error"></b-form-input> -->
                                <b-form-select v-model="dealLinesObj.penerima" placeholder="Penerima Manfaat"  :state="!$v.dealLinesObj.penerima.$error" :plain="true" :options="penerimamanfaat"></b-form-select>
                              </b-input-group>
                              <b-input-group >
                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.uraian"  :state="!$v.dealLinesObj.uraian.$error"></b-form-input>
                              </b-input-group>
                            </b-col>
                            <b-col lg="5">
                              <b-input-group >
                                <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.tanggal" type='date' :state="!$v.dealLinesObj.tanggal.$error" style="padding-right:1px;"></b-form-input>
                              </b-input-group>
                              <b-input-group>
                                  <b-input-group-prepend><label>Trx. Amount </label></b-input-group-prepend>
                                  <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span> </b-input-group-prepend>
                                  <my-number v-model="dealLinesObj.nilai" :precision="2"  :state="!$v.dealLinesObj.nilai.$error" class="form-control text-right" style="padding-right:2px !important;"></my-number>
                              </b-input-group>
                            </b-col>
                          </b-row>
                          <b-row class="justify-content-center">
                              <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveDealLines()">Update</b-button>
                              <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                          </b-row>
                      </b-card>
                      </template>                        
                  </b-table>
                  <b-row class="mt-1">
                            <b-col cols="7">
                              <div style="display: inline;font-size:smaller;">
                                Showing {{(dealLines.page - 1) * dealLines.limit + 1}}
                                to <span v-if="((dealLines.page * dealLines.limit)>dealLines.total)">{{dealLines.total}}</span> <span v-else>{{dealLines.page * dealLines.limit}}</span>
                                of {{dealLines.total}} entries,<span class="ml-2 mr-1">limit per page :</span> 
                                <select  v-model="dealLines.limit"  style="width:40px;">
                                  <option>12</option>
                                  <option>24</option>
                                  <option>36</option>
                                </select>
                              </div>
                              <b-button size="sm" class="ml-1" @click="addDealLines" >Add item</b-button>  
                            </b-col>
                            <b-col cols="5">            
                              <b-pagination 
                                align="right" size="sm"
                                :total-rows="dealLines.total"
                                :per-page="dealLines.limit"
                                v-model="dealLines.page"
                              ></b-pagination>
                            </b-col>
                  </b-row>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label style="width:180px;">Claim Requested Amount </label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                        <my-number v-model="dealLines.rekapfix" :precision="2"  disabled class="form-control text-right"></my-number>
                        <b-input-group-prepend><label style="margin-left:5px;width:120px;">Approved Amount </label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span> </b-input-group-prepend>
                        <my-number v-model="model.TakenAmount" :precision="2" disabled  class="form-control text-right"></my-number>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label style="width:130px;">Plan Payment Date </label></b-input-group-prepend>
                        <b-form-input v-model="model.PaymentDate" type='date' :state="!$v.model.PaymentDate.$error"></b-form-input>
                        <b-form-radio-group  v-model="model.PayMethod" name="radioPayMethod" class="ml-2 mt-1" >
                            <b-form-radio value="With Payroll">Pay With Payroll</b-form-radio>
                            <b-form-radio value="After Payroll">Pay After Payroll</b-form-radio>
                        </b-form-radio-group>
                        <button  v-if="saveEnabled" class="btn btn-primary ml-2 mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                        <b-button class="btn btn-primary mr-2" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
                    </b-input-group>
                </b-col>
                
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuBenefitShow" size="lg" :hide-footer="true" title="List of Benefit" :centered="true" :lazy="true">
            <lku-benefit @click="onSelectLkuBenefit" ></lku-benefit>
        </b-modal>        
        <b-modal v-model="lkuBenefitenttlShow" size="lg" :hide-footer="true" title="List of Benefit Entitlemnet" :centered="true" :key="model.crewkey">
            <lku-benefitenttl @click="onSelectLkuBenefitenttl" :crewkey="model.crewkey" :crewname="model.crewname" :ClaimID="model.ClaimID" :NmClaim="model.NmClaim" :formdata="lkuBenefitenttlData"></lku-benefitenttl>
        </b-modal>        

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 90px;
                }
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import benefitclaim from "../../apis/benefitclaim";
import lkuCrew from "../lookup/lkuCrew";
import lkuBenefit from '../lookup/lkuBenefit';
import lkuBenefitenttl from '../lookup/lkuBenefitenttl';
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{Loading,myNumber,lkuCrew, lkuBenefit,lkuBenefitenttl},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            TakenDate: {required },
            TakenReason: { required },
            TotalClaim: { required },
            ClaimEnttlId: { required },
            ClaimID: { required },
            PaymentDate: { required }
        },
        dealLinesObj: {
            tanggal: { required },
            uraian : { required },
            penerima: { required },
            nilai : { required },
        },
  }, 
  data () {
    return {
        isLoading:false,
        benefitclaimMenu:'',
        user: this.$store.state.user,
        saveEnabled:true,
        model:{crewkey: '',TakenDate:'',
            TotalClaim: 0, TakenAmount: 0,startdate:'',ClaimID: '',ClaimEnttlId:'',
            TakenReason: '', PayMethod: 'With Payroll', matauang:'IDR' },
        lkuCrewShow:false,
        lkuBenefitShow:false,
        lkuBenefitenttlShow:false,
        lkuBenefitenttlData:{},
        currency:[{value:'IDR',text:'IDR'}],
        penerimamanfaat:['Karyawan','Suami', 'Istri', 'Anak' ],
        dealLines: {
            items: [],
            selected:{},
            fields: [
                {
                    key: "tanggal",
                    label: "Trx.Date",
                    sortable:true
                },
                {
                    key: "uraian",
                    label: "description",
                },
                {
                    key: "penerima",
                    label: "beneficiary",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 12,
            total: 0,
            rekapfix:0,
        },
        dealLinesObj:{nilai:0, tanggal:''},
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidDealLines() {
        this.$v.dealLinesObj.$touch();
        return this.$v.dealLinesObj.$invalid;
      },
  },
  created: async function(){
      this.benefitclaimMenu = localStorage.getItem('benefitclaimMenu');

      if (this.$route.params.ClaimHistID)  {
          toastr.info('Loading Claim Detail, please wait')
          try {
            const data = await benefitclaim.detail(this.$route.params) ;
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
        this.model.TakenDate=moment(row.TakenDate).format('YYYY-MM-DD');
          this.model.PlatfrmBlc += this.model.TakenAmount; 

          this.dealLines.items = data[1];
          this.calcTotal();        

            // this.$forceUpdate();

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
        this.model.TakenDate=moment().format('YYYY-MM-DD');
        if (this.benefitclaimMenu=='hrm.benefitclaimself') {
          this.model.crewinfo = this.user.full_name.trim() + ' | ' + this.user.crewnik;
          this.model.crewkey=this.user.crewkey;
          this.model.crewname=this.user.full_name;
          this.model.crewnik=this.user.crewnik;
          this.model.jabatan=this.user.jabatan;
          this.model.departemen=this.user.departemen;
        }
      }
  },
  methods:{
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    onSelectLkuBenefit: function(_selected){
        this.model.ClaimID =_selected.ClaimID;
        this.model.NmClaim =_selected.NmClaim;
        this.model.MaxClaim =_selected.MaxClaim;
        this.model.PaidPerClaim= _selected.PaidPerClaim;
        this.lkuBenefitShow=false;
    },    
    onSelectLkuBenefitenttl(invLookup) {
        this.model.ClaimEnttlId=invLookup.selected.ClaimEnttlId;
        this.model.Periode=invLookup.selected.Periode;
        this.model.ClaimID=invLookup.selected.ClaimID;
        this.model.NmClaim=invLookup.selected.NmClaim;
        this.model.PaidPerClaim= invLookup.selected.PaidPerClaim;
        this.model.crewkey=invLookup.selected.crewkey;
        this.model.crewinfo=invLookup.selected.crewinfo;
        this.model.crewname=invLookup.selected.crewname;
        this.model.crewnik=invLookup.selected.crewnik;
        this.model.matauang=invLookup.selected.matauang;
        this.model.MaxClaim=invLookup.selected.MaxClaim ;
        this.model.MaxKali=invLookup.selected.MaxKali ;
        this.model.MaxKaliBlc=invLookup.selected.MaxKaliBlc ;
        this.model.MaxClaim=invLookup.selected.MaxClaim ;
        this.model.PlatfrmBlc=invLookup.selected.PlatfrmBlc;
        this.model.TotalTaken=invLookup.selected.TotalTaken;
        this.model.TotPlatform=invLookup.selected.TotPlatform;
        this.lkuBenefitenttlShow=false;
        this.lkuBenefitenttlData=invLookup;
    },    
    closeDealLines: function(){
        const opened= this.dealLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    calcTotal: function() {
        this.model.PlatfrmBlc = parseFloat(this.model.PlatfrmBlc);
        this.dealLines.total=this.dealLines.items.length;
        this.dealLines.rekapfix = this.dealLines.items.reduce((a, b) => a + parseFloat(b.nilai), 0);
        this.model.TotalClaim = this.dealLines.rekapfix;
        const realAmt=(parseFloat(this.model.PaidPerClaim)/100) * this.model.TotalClaim;
        if (realAmt < this.model.PlatfrmBlc) {
             this.model.TakenAmount = realAmt;
        } else {
             this.model.TakenAmount = this.model.PlatfrmBlc;
        }
       
    },
    addDealLines : function () {
        this.closeDealLines();
        const obj={_showDetails:true,IdKompGaji:'', rumus:'', fixincome:'0', NilaiKomp:''};
        this.dealLines.selected = obj;
        this.dealLinesObj.tanggal = this.model.TakenDate;
        this.dealLinesObj.fixincome=1;
        this.dealLinesObj.NilaiKomp = 0;
        this.dealLinesObj.rumus = '';
        this.dealLinesObj.IdKompGaji = '';
        this.dealLines.items.push(obj);
        this.dealLines.total=this.dealLines.items.length;
    },
    editDealLines : function (obj,callback) {
        if (obj.payrolldtkey) {
            toastr.error('Paid Settlment can not be edit/delete', "Error Info");
        } else {
          this.closeDealLines();
          this.dealLines.selected = obj;
          for (var key in this.dealLinesObj) {
              this.dealLinesObj[key] = '';
          }
          for (var key in obj) {
              this.dealLinesObj[key] = obj[key];
          }
          callback();
        }
    },
    delDealLines: function (index) {
        if (index > -1) {
          if (this.dealLines.items[index].payrolldtkey) {
              toastr.error('Paid Settlment can not be edit/delete', "Error Info");
          } else {
            this.dealLines.items.splice(index, 1);
          }
        }
        this.calcTotal();        
    },
    saveDealLines: async function (callback) {
        if (this.invalidDealLines) {
            console.log('validation : ', this.$v.dealLinesObj);
            console.log('model obj : ',this.dealLinesObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              for (var key in this.dealLinesObj) {
                  this.dealLines.selected[key] = this.dealLinesObj[key];
              }
              this.calcTotal();        
              this.dealLines.selected._showDetails=false;
              if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },

    save: async function(){
        this.isLoading=true;
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
            this.isLoading=false;
       } else {
            try {
              const data={};
              data.benefitclaimMenu=this.benefitclaimMenu;
              for (var key in this.model) {
                  data[key] = this.model[key];
              }     
              data.TakenDate = moment(this.model.TakenDate).format('YYYY-MM-DD');
              data.PaymentDate = moment(this.model.PaymentDate).format('YYYY-MM-DD');

              let newDealLines = this.dealLines.items.reduce((newArr, item) => {
                  if ((item.tanggal) && (item.nilai) ) {
                      item.trxDate = moment(item.tanggal).format('YYYY-MM-DD');
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              this.dealLines.items=newDealLines;
              this.calcTotal();

              data.lines = newDealLines;
              const hasil= await benefitclaim.save(data);
              this.isLoading=false;
              toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Request",10000);
              this.close();
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },
    close(){
      if (this.benefitclaimMenu=='hrm.benefitclaimself')  router.push({name: 'hrm.benefitclaimself'});
      else  router.push({name: 'hrm.benefitclaim'});
    },    
  }
}
</script>